import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Part from './Part'

export default class Group extends Component {
  static propTypes = {
    config: PropTypes.object.isRequired,
    step: PropTypes.object.isRequired,
    template: PropTypes.any.isRequired,
    templates: PropTypes.object.isRequired,
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   return true
  // }

  render() {
    const {
      config,
      step,
      templates,
      formik,
      form
     } = this.props
    const parts = config.parts
    const Template = this.props.template // Capitalized to enable React Component rendering
    
    return (
      <Template
        config={config}
        step={step}
        formik={formik}
        form={form}
      >
        {
          parts.map((part, i) => <Part key={i} config={part} step={step} formik={formik} form={form} templates={templates} />)
        }
      </Template>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Form/Group.js